import React, { Component } from 'react'; 
// import "../dashboard/Dashboard.css"
class Footer extends Component {
  render () {
    return (
      <footer className="footer" id='dashFooter' style={{
          background: '#fff',
          padding: '20px 30px',
          borderTop: '1px solid #e8e8e8',
          marginTop: 'auto',
          boxShadow: '0 -2px 10px rgba(0,0,0,0.02)'
      }}>
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
            <span className="text-center text-sm-left d-block d-sm-inline-block" style={{
                color: '#777',
                fontFamily: "'Poppins', sans-serif",
                fontSize: '14px',
                fontWeight: '500'
            }}>
              Copyright © <a href="https://wa.me/+919817694914" target="_blank" rel="noopener noreferrer" style={{
                  color: '#57155a', 
                  fontWeight: '700', 
                  textDecoration: 'none',
                  transition: 'color 0.3s ease'
              }}>Rp Gaming LTD.</a> 2026
            </span>
            
            <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center" style={{
                color: '#999',
                fontSize: '13px',
                fontFamily: "'Poppins', sans-serif"
            }}>
              Admin Panel v2.0
            </span>
          </div>
        </div>
      </footer>
    );
  }
}
export default Footer;